import { useMutation } from '@tanstack/react-query'
import { LeadsInfoClientRequest } from '../../../@types/LeadsInfo'
import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import { apiLeads } from '../../../Services/API/LeadsAPI'
import { useWarningStore } from '../../../Stores/warningStore'
import { WARNING_BAR } from '../../../constants/warningBar'
import { t } from '../../../i18n'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: LeadsInfoClientRequest) => {
  const response = await apiLeads.post<any>(
    "/",
    payload,
  )

  return response.data
}

export const useLeadsInfo = () => {

  return useMutation({
    mutationFn: (payload: LeadsInfoClientRequest) =>
      request(payload!),
    onSuccess(data) {
        console.log(`Lead associada ${data.leadId}`)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
        console.log(`Erro ao associar a Lead: ${error}`)
    },
  })
}
